import React, { FC } from 'react';
import styled from 'styled-components/native';

import { IDemoAccountResponse } from '@webtrader/core/api/experienceDemo';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';

import Text from '@/components/Text';
import { ALL_MOBILE_ROUTES, replace, useExperienceResetPasswordRouteParams } from '@/utils/navigation';

import NavigationHeader from '../../Header';
import ResetPasswordForm from './Form';

const ExperienceDemoResetPasswordScreen: FC = () => {
  const { t } = useTranslation();
  const params = useExperienceResetPasswordRouteParams();
  const { setNeedUpdateFields } = params || {};

  const onSuccess = (result: IDemoAccountResponse) => {
    replace(ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_COMPLETION, {
      title: t('We’ve reset your password.'),
      subTitle: t('Your demo account is ready.'),
      accountDetails: result,
      setNeedUpdateFields
    });
  };

  return (
    <Container>
      <Screen>
        <NavigationHeader title={t('Reset Password')} />
      </Screen>
      <StyledScrollView>
        <HeaderDescription>
          {t('Gain instant demo access with your email, and receive login details in your inbox.')}
        </HeaderDescription>
        <StyledFormContainer>
          <ResetPasswordForm onSuccess={onSuccess} />
        </StyledFormContainer>
      </StyledScrollView>
    </Container>
  );
};

export default ExperienceDemoResetPasswordScreen;

const StyledScrollView = styled.ScrollView`
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

const Container = styled.View`
  flex: 1;
`;

const Screen = styled.View`
  padding-start: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-end: ${({ theme }) => theme.sizes.mobile.basePaddingEnd}px;
`;

const HeaderDescription = styled(Text)`
  padding: ${dynamicSize.convertSize(16)}px ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-top: ${dynamicSize.convertSize(4)}px;
  color: ${({ theme }) => theme.colors.text[1]};
  font-size: ${dynamicSize.convertSize(15)}px;
  line-height: ${dynamicSize.convertSize(22)}px;
`;

const StyledFormContainer = styled.View`
  padding: ${dynamicSize.convertSize(12)}px ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
`;
